import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const TheContextFamilyOfficesBlog = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '38px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '62px' }}
            >
              Family offices – Driving the evolution of AIFs in India
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '40px' }}
          mb="20px"
        >
          <Flex
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
            gap="20px"
            alignItems={{
              xs: 'center',
              md: 'unset',
            }}
          >
            <Img
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-01-22at22512PM-30WTpjkxjC3F.png"
              alt="Vikaas M Sachdeva
"
              width="250px"
              height="250px"
              objectFit="cover"
              borderRadius="50%"
            />
            <Flex direction="column">
              <Heading
                as="h1"
                fontWeight="800"
                pt="20px"
                variant="reportCardTitle"
                fontSize={{ xs: '16px', md: '18px', lg: '20px' }}
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Vikaas M Sachdeva
                <Link
                  href="https://www.linkedin.com/in/vikaasmsachdeva/?originalSubdomain=in"
                  target="_blank"
                  display={{ xs: 'inline-block', md: 'none' }}
                  pl="10px"
                >
                  <IconButton
                    aria-label="linkedin"
                    icon={<FaLinkedin size="28px" color="#067acc" />}
                    variant="unstyled"
                    cursor="pointer"
                  />
                </Link>
              </Heading>
              <Text
                color="text.mediumBlack"
                maxW={{
                  xs: '100%',
                  md: '120px',
                }}
                w="100%"
                fontSize="16px"
                lineHeight="22px"
                fontStyle="italic"
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Managing Director, Sundaram Alternates
              </Text>

              <Link
                href="https://www.linkedin.com/in/vikaasmsachdeva/?originalSubdomain=in"
                target="_blank"
                display={{
                  xs: 'none',
                  md: 'block',
                }}
              >
                <IconButton
                  aria-label="linkedin"
                  icon={<FaLinkedin size="28px" color="#067acc" />}
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Box mt="16px" mb="20px">
            <Text variant="blogAnswer">
              In the evolving financial landscape of India, family offices are
              emerging as pivotal players in the alternate investment space.
              Once limited to preserving wealth for future generations, these
              exclusive advisory firms are now at the forefront of wealth
              creation and innovation, driving growth across asset classes and
              industries. This transformation is fuelled by several key trends,
              including professionalisation, diversification, and a shift toward
              embracing alternative investment strategies.
            </Text>
          </Box>

          {/* 1 */}

          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              1. A shift toward professionalisation
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The journey of family offices from wealth custodians to
              next-generation wealth creators is rooted in their commitment to
              professionalise operations. Today, over 70% of family offices in
              India recognise the need for a governance-driven, process-oriented
              approach to wealth management.1 This shift is not just about
              enhancing efficiency but also about aligning with modern
              investment philosophies. Key drivers such as succession planning,
              impact investing, and the involvement of millennials and
              Generation Z are pushing family-run businesses to adopt innovative
              strategies. The infusion of professional expertise ensures that
              family offices remain resilient in an increasingly complex
              financial environment.
            </Text>
          </Box>
          {/* 3  */}
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              2. From preservation to creation
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              Traditionally, family offices were focused on safeguarding wealth
              through prudent asset allocation, tax planning, and financial
              management. However, as India witnesses a surge in entrepreneurial
              ventures and liquidity events, family offices are transitioning
              from wealth preservation to wealth creation. This transition is
              particularly evident in scenarios where families have experienced
              liquidity events, such as the sale of a business. The resulting
              capital surplus has driven the establishment of family offices
              with a mandate to invest strategically in growth opportunities.
              Many now view these entities as engines of wealth creation,
              emphasising long-term growth while maintaining an optimal balance
              with wealth preservation.
            </Text>
          </Box>
          {/* 4 */}
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              3.Growing importance of Alternative Investment Funds (AIFs)
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The growth of global wealth has significantly increased the number
              of family offices, which currently stands at approximately 10,500
              worldwide. In India, the number of family offices is estimated at
              over 300, reflecting a growing shift toward personalised and
              professional wealth management to safeguard and grow family assets
              across generations. This trend is poised for robust growth, with
              the AUM of mid to large-sized family offices projected to grow at
              a CAGR of at least 14% over the next three years, potentially
              increasing by 1.5 times during this period. Further, AIFs are set
              to play a pivotal role in this evolving ecosystem, offering family
              offices a strategic gateway to private markets, enabling them to
              diversify portfolios and explore high-potential areas like venture
              capital, venture debt, hedge funds, and private equity. Globally,
              family offices are allocating a significant proportion of their
              portfolios to AIFs, leveraging their long-term perspective and
              "patient capital." While Indian family offices currently dedicate
              a smaller share of their portfolios to AIFs compared to their
              global counterparts, this is rapidly changing. Many prominent
              Indian family offices are eyeing an increase in AIF allocations by
              up to 5%, recognising their potential to enhance portfolio
              performance and mitigate risks associated with traditional
              investment products.
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              4. The growing appetite for global investments
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              Indian family offices are increasingly seeking global exposure to
              diversify their portfolios and enhance long-term wealth creation.
              Many are leveraging AIFs as a strategic avenue to access
              international markets, co-investment opportunities, and private
              market assets. These funds provide a structured approach to
              explore venture capital, private equity, and global startup
              ecosystems. AIFs also offer family offices the ability to
              participate in professionally managed investments while benefiting
              from international best practices. By aligning with venture
              capital-focused AIFs and engaging in co-investments, family
              offices can access unique opportunities, gain global insights, and
              refine their investment strategies, addressing their growing need
              for diversification and innovation.
            </Text>
          </Box>

          {/*  */}
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              5. Evolving objectives and generational shifts
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The objectives of family offices are evolving, driven by
              generational shifts and changing market dynamics. Younger leaders
              are emphasising investments that align with values like
              sustainability and impact investing and this shift is evident in
              increased allocations to AIFs. Initially, VC-focused AIFs served
              as a learning ground, helping them navigate entrepreneurial
              ventures but with growing expertise, many family offices are now
              transitioning their investment styles and opting for direct
              investments, supported by professional teams. As India’s financial
              ecosystem matures, family offices are shaping the alternate
              investment landscape, blending tradition with innovation and
              contributing to economic growth and sustainability. <br />
              <br /> Going into 2025, family offices are no longer just
              custodians of wealth; they are architects of legacies, driving the
              transformation of India’s alternate investment space with a vision
              that bridges tradition and innovation.
              <br />
              <br />
              <Box my="8px">
                <Text variant="blogAnswer">
                  Source:
                  <Link
                    href="https://www.sundaramalternates.com/family-office-report"
                    target="_blank"
                    fontWeight="700"
                    ml="4px"
                    style={{ color: 'blue', textDecoration: 'underline' }}
                  >
                    https://www.sundaramalternates.com/family-office-report
                  </Link>
                </Text>
              </Box>
              Disclaimer: <br />
              Securities investments are subject to market risks and there is no
              assurance or guarantee that the objective of the investments will
              be achieved.
            </Text>
          </Box>
          {/*  */}
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default TheContextFamilyOfficesBlog;
